// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_35-1";
export var movingGradient = "_35-4";
export var movingGradientBlock = "_35-2";
export var skeleton = "_35-0";
export var skeletonText = "_35-3";